import { useMemo } from "react"
import { useSelector } from "react-redux"
import { LevelSettingType } from "@/api/FacilityLevelsService"
import { RootState } from "@/store"
import { formatLevelSettings } from "@/utils/facilities"

export function useDynamicThresholdsEnabled(): boolean {
   const { facilityDetails } = useSelector(
      ({ facilitiesReducer }: RootState) => facilitiesReducer
   )

   return useMemo(() => {
      const settings = facilityDetails.settings
      if (!settings || settings.length === 0) return false
      return !!formatLevelSettings(settings)[
         LevelSettingType.DYNAMIC_THRESHOLDS_ENABLED
      ]
   }, [facilityDetails.settings])
}
